import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import theme from './BuyerOptionCard.module.scss';
import { BuyerCurrencyDisplay } from '../../../buyer/components/BuyerCurrencyDisplay';
import { ConfiguratorOptionDto, ConfiguratorPriceDto } from '@/services/configurator';
import { classnames } from '@/utils/html';

export interface BuyerOptionCardPriceProps {
    option: ConfiguratorOptionDto;
    /** Show this price instead of `option.price` — used for a live (unsaved) quantity preview. */
    priceOverride?: ConfiguratorPriceDto | null;
    /** Dim the price and show a spinner while a live recalculation is in flight. */
    loading?: boolean;
    /** Compact size (14px) — matches the showroom compact option/group rows. */
    compact?: boolean;
}

export const BuyerOptionCardPrice: React.FC<BuyerOptionCardPriceProps> = ({
    option,
    priceOverride,
    loading,
    compact,
}) => {
    const price = priceOverride ?? option.price;
    if (!price) {
        return null;
    }

    // Only the final price is shown; the per-unit breakdown (unitPrice × quantity unit) is omitted —
    // the group's quantity + unit is surfaced separately via the group quantity pill. `price` (not
    // `option.price`) is used so a live, unsaved quantity preview still drives the displayed total.
    const { finalPrice } = price;
    return (
        <div
            className={classnames(theme.priceElement, {
                [theme.priceLoading]: loading,
                [theme.priceElementCompact]: compact,
            })}>
            <span className={theme.priceValue}>
                {loading && <FontAwesomeIcon icon={faSpinner} spin className={theme.priceSpinner} />}
                <BuyerCurrencyDisplay value={finalPrice || 0} alwaysShowSign />
            </span>
        </div>
    );
};
